<template>
  <div class="rodemap">
    <WordDialog :data="arr[index]" @jump="jump"></WordDialog>
  </div>
</template>

<script>
//script
import Tools from '../../../scripts/tools';
import { gsap } from 'gsap';
//Global
import Global from '../../../scripts/Global';
import WordDialog from '../../cmp/wordDialog';

export default {
  data() {
    return {
      index: 0,
      arr: [
        {
          headImg: '苏尚卿讲解',
          word:
            '浮碧亭位于御花园东北，亭北正对倚园北墙而建的摛藻堂，正南是万春亭。亭下有一方矩形水池，池水引自护城河，池中芙蓉出水，游鱼穿泳，为御花园的景色增添了清新活泼的情趣。 ',
          audio: 'ssq',
          scene: 'scene12',
        },
      ],
    };
  },
  components: {
    WordDialog,
  },
  created() {},
  computed: {},
  methods: {
    jump(event) {
      this.$router.replace('/rodemap/ssq/08');
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.rodemap {
  background-image: url(//cdn.original-fun.com/gugong/浮碧亭.jpg);
  background-position: center;
  width: 100vw;
  height: 100vh;
  max-width: 75vh;
  margin: 0 auto;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
